module.exports = __webpack_public_path__ + "img/registration.8a030519.svg";